import React from "react"
import { appTools, cn } from "lib/utils"



export default function FormButton({ 
  type="submit",
  children, 
  className, 
  error=null,
  ...rest
}:{ 
  type?:"submit" | "reset" | "button" | undefined
  className?:string
  error?:any
  [key:string]:any 
}){

  return (
    <button 
      type={type} 
      className={cn(
        "border border-solid border-teal-700 rounded-sm h-8 flex justify-start items-center bg-teal-900 outline-transparent outline outline-offset-2 text-sm text-gray-200 px-5 py-.5 whitespace-nowrap", 
        error && "outline-red-700",
        className
      )} 
      {...rest}
    >
      { children }
    </button>
  )
}